import { NamedRoute } from "@/jenesys-types/routes/routes";

import { ClientDashboardRoute } from "@/components/routes/clients/ClientIndexRoute";
import { CompanyIndexRoute } from "@/components/routes/company/CompanyIndexRoute";
import setupClientQueriesRoute from "@/routes/client/ClientQueriesRoute";
import setupDocumentIngestRoute from "@/routes/client/ingest";
import setupReconciliationRoute from "@/routes/client/reconciliation";
import setupClientSettingsRoute from "@/routes/client/settings";
import setupTransactionsRoute from "@/routes/client/transactions";

import setupCompanyQueriesRoute from "./CompanyQueriesRoute";
import setupManageClientRoute from "./manageClient";
import setupCompanySettingsRoute from "./settings";

export const ROOT_PATH = "company";

// A function to setup standalone client routes directly at the company level
// These routes mirror the structure from client.tsx but without the 'client/:clientId' prefix
const setupClientRoutes = (): NamedRoute[] => [
  {
    name: "clientdashboard",
    index: true,
    element: <ClientDashboardRoute />
  },
  setupTransactionsRoute(),
  setupReconciliationRoute(),
  setupClientSettingsRoute(),
  setupDocumentIngestRoute(),
  setupClientQueriesRoute()
];

// The regular company routes that would be used for practices
const setupPracticeRoutes = (): NamedRoute[] => [
  {
    name: "dashboard",
    index: true,
    element: <CompanyIndexRoute />
  },
  setupManageClientRoute(),
  setupCompanySettingsRoute(),
  setupCompanyQueriesRoute()
];

// Export the route setups for external use
export { setupClientRoutes, setupPracticeRoutes };
